angular.module( 'acme.view.application.programs.modals.cannotRelink', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.programs.modals.cannotRelink.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var programsModalsCannotRelink = {
        name: 'application.programs.modals.cannotRelink',
        url: '/programs/modals/cannotRelink',
        views: {
          "main": {
            controller: 'ProgramsModalsCannotRelinkController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/programs/modals/cannotRelink/cannotRelink.tpl.html'
          }
        },
        data: {
          pageTitle: '   ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(programsModalsCannotRelink);
});
